import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'


const Id2 = () => {

    const detail = 
        {
            id:24,
            imgSrc:cover,
            ini:'The training on “Pathogen detection and diversity analysis – Introduction to bioinformatics” (November 24–28, 2025) at the Faculty of Associated Medical Sciences, CMU.',
            href:'',
            element:'',
            topic:'The event took place from November 24–28, 2025, at Building 3, 6th Floor, Faculty of Associated Medical Sciences, Chiang Mai University. We were honored to have Asst. Prof. Dr. Kanya Preechasuth, Head of the Division of Clinical Microbiology, Faculty of Associated Medical Sciences, CMU, preside over the opening ceremony. Throughout the event, distinguished experts Dr. Vanina Guernier (IEES, IRD) and Mr. Mathis Arnal (PRESTO - MIVEGEC, IRD) shared their extensive knowledge and guided the participants. The primary objective of this workshop was to enhance academic potential by focusing on Molecular Diagnostics and fundamental Bioinformatics skills—essential tools in modern medical research. The training aimed to equip researchers and participants with the ability to apply this knowledge to accurately analyze and classify pathogen diversity. The organizing team would like to express our sincere gratitude to the speakers and all participants for exchanging knowledge and building academic networks. We also extend our special thanks to the Division of Clinical Microbiology for kindly providing the venue for this event.',
            inform:``
        ,
            link1:`https://www.facebook.com/photo.php?fbid=843902338613920&set=a.148346398169521&type=3`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
